/**
 * Display name for an admin-managed row that carries a `nameI18n` locale map
 * (markets, offer stages): the viewer's language, then English, then the
 * canonical `name` column the row has always had.
 *
 * These are configuration lists, not translated content: the map is the whole
 * translatable surface, so this stays a two-line lookup rather than a join.
 */
export function localizedName(
  row: { name: string; nameI18n?: Record<string, string> | null },
  locale: string,
): string {
  const map = row.nameI18n ?? {};
  return map[locale]?.trim() || map.en?.trim() || row.name;
}

/**
 * The language a catalog entry (product, product line) is shown in: the
 * viewer's own, then English, then Serbian — the same order the server uses.
 * Entries from the ERP are named in Serbian and often have no English name;
 * without the last step the viewer sees a code where a name exists.
 * Undefined when none of these three languages has a name.
 */
export function catalogLocale(
  translations: Record<string, { name?: string | null } | undefined> | null | undefined,
  locale: string,
): string | undefined {
  const map = translations ?? {};
  return [locale, "en", "sr"].find((l) => map[l]?.name?.trim());
}
